export enum MinimalTestimonialSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'marge',
}

export interface MinimalTestimonialProps {
  name: string;
  title: string;
  image: string;
  size: MinimalTestimonialSize;
}
